import React from "react";

const AdminUsers = () => {
  return <h2>Manage Users</h2>;
};

export default AdminUsers;
